'use es6';

import http from 'hub-http/clients/apiClient';
/**
 * PUT designmanager/v1/layouts/:id/push-buffer-live
 */

export function publish(layoutId, layout) {
  return http.put(`designmanager/v1/layouts/${layoutId}/push-buffer-live`, {
    data: Object.assign({}, layout, {
      meta: {
        hasBufferedChanges: false
      }
    }),
    timeout: 15000,
    query: {
      designManagerUpdatedFrom: 'IDE'
    }
  });
}
/**
 * PUT designmanager/v1/layouts/:id
 */

export function save(layoutId, layout) {
  return http.put(`designmanager/v1/layouts/${layoutId}`, {
    data: layout
  });
}
/**
 * DELETE  designmanager/v1/layouts/unified/:layoutId
 */

export function del(layoutId) {
  return http.delete(`designmanager/v1/layouts/${layoutId}`);
}
/**
 * DELETE designmanager/v1/layouts/bulk?id=1&id=2
 */

export function bulkDelete(layoutIds) {
  return http.delete('designmanager/v1/layouts/bulk', {
    query: {
      id: layoutIds
    }
  });
}
/**
 * POST designmanager/v1/layouts
 */

export function create(layout) {
  return http.post('designmanager/v1/layouts', {
    data: layout
  });
}
/**
 * POST designmanager/v1/layouts/:id/clone
 */

export function clone(layoutId, {
  label,
  folder,
  folderId
}) {
  return http.post(`designmanager/v1/layouts/${layoutId}/clone`, {
    data: {
      label,
      folder,
      folderId
    }
  });
}
/**
 * POST designmanager/v1/layouts/:id/clone-to-template
 */

export function cloneToFile(layoutId, layout) {
  return http.post(`designmanager/v1/layouts/${layoutId}/clone-to-template`, {
    data: layout
  });
}
/**
 * POST designmanager/v1/layouts/:id/discard-buffer
 */

export function discardBuffer(layoutId) {
  return http.post(`designmanager/v1/layouts/${layoutId}/discard-buffer`);
}
/**
 * GET designmanager/v1/layouts/:layoutId
 */

export function fetch(layoutId) {
  return http.get(`designmanager/v1/layouts/${layoutId}`);
}
/**
 * GET designmanager/v1/layouts?:query
 */

export function fetchQuery(query = {}) {
  return http.get('designmanager/v1/layouts', {
    query
  });
}
/**
 * PUT designmanager/v1/layouts/:layoutId/restore-deleted
 */

export function restoreDeleted(layoutId) {
  return http.put(`designmanager/v1/layouts/${layoutId}/restore-deleted`);
}